<h1 mat-dialog-title>Solicitud HIS</h1>
<div mat-dialog-content>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <div *ngIf="!loading">
        <div></div> Paciente: <span> <b> {{ request.PatientFullName}} </b>  </span>
        <div>Ubicación: <span> <b> {{ request.Location}} </b> </span></div>
        <div>Observaciones: <span> <b> {{ request.Observations}} </b> </span></div>
        <div>Motivo: <span> <b> {{ request.Reason }} </b> </span></div>
        <div>Prácticas: </div>
        <span *ngFor="let item of request.Procedures"> <b> {{ item.Name }}   ( {{ item.Amount }} ) </b></span>
    </div>
</div>
<div class="clearfix">
    <div *ngIf="!loading" class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>